import type { FC } from 'react';
import { useEffect } from 'react';
import { toast } from 'sonner';
import type { OperatorDocument } from 'src/apis/document-exchange/types';
import { useDocumentWithdraw } from 'src/apis/document-exchange/use-document-withdraw';
import { Button } from 'src/components/buttons-and-actions/button';
import { TableActions } from 'src/components/buttons-and-actions/table-actions';
import { Link } from 'src/components/navigation/link';
import { useModal } from 'src/hooks/use-modal';
import { WithdrawDocumentModal } from 'src/pages/shippers/documents/components/withdraw-document-modal';

export const DocumentActions: FC<{
  refreshDocuments?: () => void;
  data: OperatorDocument;
  index: number;
}> = ({ refreshDocuments, index, data }) => {
  const withdrawLink = data._links.withdrawOperatorDocument?.href;
  const documentWithdraw = useDocumentWithdraw();

  const withdrawModal = useModal(
    withdrawLink
      ? (props) => (
          <WithdrawDocumentModal
            documentWithdraw={documentWithdraw}
            withdrawLink={withdrawLink}
            onDismiss={props.close}
          />
        )
      : null
  );

  useEffect(() => {
    if (!documentWithdraw?.response) return;
    withdrawModal?.close();

    toast.success('Document withdrawn.');
    if (refreshDocuments) {
      refreshDocuments();
    }
    // oxlint-disable-next-line exhaustive-deps
  }, [documentWithdraw?.response]);

  return (
    <TableActions testId={data.operatorDocumentId}>
      {data.documentStatus === 'PUBLISHED' ? (
        <>
          {data._links.getOperatorDocumentVersionHistory ? (
            <Link to={`/shippers/documents/${data.operatorDocumentId}`}>
              Edit
            </Link>
          ) : null}

          {withdrawModal ? (
            <Button
              data-testid={`actions-dropdown-withdraw-${index}`}
              onClick={withdrawModal.open}
            >
              Withdraw
            </Button>
          ) : null}
        </>
      ) : null}
    </TableActions>
  );
};
